import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import {
  CustomerRuleConditionsDTO,
  CustomerRuleParametersDTO,
  RuleComparisonType,
  RuleConditionType,
  RuleDefinitionConditionDTO,
  RuleDefinitionLicenseDTO,
  RuleDefinitionParameterDTO,
  RuleParameterType,
} from 'src/app/core/services/AdminService/admin-service-generate';

interface valueSourceList {
  valueSourceList: string[];
}
@Component({
  selector: 'app-rule-details',
  templateUrl: './rule-details.component.html',
  styleUrls: ['./rule-details.component.css'],
})
export class RuleDetailsComponent implements OnInit {
  ruleDefinitionConditions: RuleDefinitionConditionDTO[];
  ruleDefinitionLicenses: RuleDefinitionLicenseDTO[];
  ruleParameters: CustomerRuleParametersDTO[];
  ruleConditions: CustomerRuleConditionsDTO[];
  tempRuleDefinitionConditions: RuleDefinitionConditionDTO[];
  tempRuleDefinitionLicenses: RuleDefinitionLicenseDTO[];
  tempRuleParameters: CustomerRuleParametersDTO[];
  tempRuleConditions: CustomerRuleConditionsDTO[];
  valueSourceListList: valueSourceList[];
  isRuleCondition: boolean = false;
  isRuleLicense: boolean = false;
  isCustomerRuleCondition: boolean = false;
  isCustomerRuleParameter: boolean = false;
  isActive: boolean = false;
  ruleConditionTypeList: RuleConditionType[] = [
    RuleConditionType.RequestField,
    RuleConditionType.EntityField,
    RuleConditionType.XPath,
  ];
  ruleComparisonTypeList: RuleComparisonType[] = [
    RuleComparisonType.IsNullOrEmpty,
    RuleComparisonType.IsNotNullOrEmpty,
    RuleComparisonType.Equal,
    RuleComparisonType.NotEqual,
    RuleComparisonType.Contains,
    RuleComparisonType.StartsWith,
    RuleComparisonType.EndsWith,
    RuleComparisonType.In,
  ];

  ruleParameterTypeList: RuleParameterType[] = [
    RuleParameterType.Constant,
    RuleParameterType.CustomerFields,
    RuleParameterType.EntityField,
    RuleParameterType.RequestField,
    RuleParameterType.XPath,
  ];
  ruleConditionIdList: RuleDefinitionConditionDTO[] = null;
  ruleParameterIdList: RuleDefinitionParameterDTO[] = null;

  @Output() oRuleDefinitionConditions = new EventEmitter<any>();
  @Output() oRuleDefinitionLicenses = new EventEmitter<any>();
  @Output() oRuleConditions = new EventEmitter<any>();
  @Output() oRuleParameters = new EventEmitter<any>();
  constructor(private dialogRef: MatDialogRef<RuleDetailsComponent>) {}

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
    this.tempRuleConditions = Object.assign([], this.ruleConditions);
    this.tempRuleParameters = Object.assign([], this.ruleParameters);
    this.tempRuleDefinitionConditions = Object.assign(
      [],
      this.ruleDefinitionConditions
    );
    this.tempRuleDefinitionLicenses = Object.assign(
      [],
      this.ruleDefinitionLicenses
    );
  }

  closeDialog(isSaved: boolean) {
    if (!isSaved) {
      this.revert();
    }
    this.oRuleConditions.emit(this.ruleConditions);
    this.oRuleParameters.emit(this.ruleParameters);
    this.oRuleDefinitionConditions.emit(this.ruleDefinitionConditions);
    this.oRuleDefinitionLicenses.emit(this.ruleDefinitionLicenses);
    this.dialogRef.close(); // <- Closes the dialog
  }
  revert() {
    this.ruleConditions = Object.assign([], this.tempRuleConditions);
    this.ruleParameters = Object.assign([], this.tempRuleParameters);
    this.ruleDefinitionConditions = Object.assign(
      [],
      this.tempRuleDefinitionConditions
    );
    this.ruleDefinitionLicenses = Object.assign(
      [],
      this.tempRuleDefinitionLicenses
    );
  }

  addRuleCondition() {
    this.ruleDefinitionConditions.push(new RuleDefinitionConditionDTO());
  }
  addCustomerRuleCondition() {
    this.ruleConditions.push(new CustomerRuleConditionsDTO());
  }
  addCustomerRuleParameter() {
    this.ruleParameters.push(new CustomerRuleParametersDTO());
  }
  deleteRuleCondition(index: number) {
    this.ruleDefinitionConditions.splice(index, 1);
  }
  deleteCustomerRuleCondition(index: number) {
    this.ruleConditions.splice(index, 1);
  }
  deleteCustomerRuleParameter(index: number) {
    this.ruleParameters.splice(index, 1);
  }
  isActiveChange() {
    this.oRuleDefinitionLicenses.emit(this.ruleDefinitionLicenses);
  }
  requiredChange() {
    this.oRuleParameters.emit(this.ruleParameters);
  }
  conditionChange(args, indeks) {
    let b: RuleDefinitionConditionDTO = null;
    for (let a = 0; a < this.ruleConditionIdList.length; a++) {
      if (this.ruleConditionIdList[a].id == args)
        b = this.ruleConditionIdList[a];
    }
    this.ruleConditions[indeks].conditionExpression = b.conditionExpression;
    this.ruleConditions[indeks].ruleDefinitionConditionsId = b.id;
    this.ruleConditions[indeks].conditionType = b.conditionType;
  }
  parameterChange(args, indeks) {
    let b: RuleDefinitionParameterDTO = null;
    for (let a = 0; a < this.ruleParameterIdList.length; a++) {
      if (this.ruleParameterIdList[a].parameterName == args)
        b = this.ruleParameterIdList[a];
    }
    this.ruleParameters[indeks].parameterName = b.parameterName;
    this.ruleParameters[indeks].parameterDescription = b.parameterDescription;
    this.ruleParameters[indeks].valueList = b.valueList;
    this.ruleParameters[indeks].required = b.required;
    this.ruleParameters[indeks].ruleDefinitionParametersId =
      b.ruleDefinitionParametersId;
  }

  valueSourceChange(args, i) {
    this.ruleParameters[i].parameterValueSource = args;
  }
}
